// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__CMSJh","ant-page-header-heading-title":"styles_ant-page-header-heading-title__LbTHf","table":"styles_table__C3jEp"};